$(function() {
    const $scrollBtn = document.querySelectorAll('.js-scroll-down'),
        headerHeight = document.querySelector('.page-header').offsetHeight;

    $scrollBtn.forEach(btn => {
        btn.addEventListener('click', function() {
            let $parentSec = this.closest('section'),
                $nextSec = $parentSec.nextElementSibling;

            if ($nextSec) {
                window.scroll({
                    top: $nextSec.offsetTop - headerHeight,
                    behavior: 'smooth'
                });
            }
        });
    });
});

// --- Scroll Top ---

(function () {
    const $scrollTopBtn = $('.js-scroll-top')

    $scrollTopBtn.on('click', function() {
        $('html, body').stop().animate({ scrollTop: 0 }, 500, 'swing');
    });
})();